import { API_URL } from "../config/backend";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Crewmate from "../components/Crewmate";
import Navbar from "../components/Navbar";
import PromoBanner from "../components/PromoBanner";

const API = API_URL;

function detectMobile() {
  const ua = navigator.userAgent || "";
  const isYandexTV = /YaApp_TV|YandexTV/i.test(ua);
  const isTVBrowser = /TV|SmartTV|AndroidTV|SMART-TV|Tizen|WebOS|BRAVIA|HbbTV|AppleTV|FireTV|Roku/i.test(ua);
  const isAndroidBig = /Android/i.test(ua) && window.innerWidth >= 960;
  const isYaBrowserBig = /YaBrowser/i.test(ua) && window.innerWidth >= 960;
  if (isYandexTV || isTVBrowser || isAndroidBig || isYaBrowserBig) return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet/i.test(ua) || window.innerWidth < 960;
}
function useMobile() {
  const [v, set] = useState(() => detectMobile());
  useEffect(() => { const h = () => set(detectMobile()); window.addEventListener("resize", h); return () => window.removeEventListener("resize", h); }, []);
  return v;
}

const GAMES_TICKER = [
  { emoji: "🧠", name: "Викторина",        color: "#ff3cac" },
  { emoji: "✏️", name: "Рисовалка",        color: "#00f5ff" },
  { emoji: "🐊", name: "Крокодил",         color: "#3dffa0" },
  { emoji: "🔥", name: "Правда/Действие",  color: "#ff8c00" },
  { emoji: "⚡",  name: "Реакция",          color: "#00f5ff" },
  { emoji: "🎵", name: "Угадай мелодию",   color: "#9b5de5" },
  { emoji: "🏆", name: "Своя игра",        color: "#FFD700" },
  { emoji: "🚗", name: "Бамперные машинки",color: "#ff3355" },
  { emoji: "💬", name: "Закончи фразу",    color: "#00DDFF" },
  { emoji: "🎡", name: "Поле чудес",       color: "#FF6B6B" },
  { emoji: "🤥", name: "Фиббедж",          color: "#B24BF3" },
  { emoji: "🐦", name: "Птичий забег",     color: "#6BCB77" },
  { emoji: "🧩", name: "Музыкальный пазл", color: "#C77DFF" },
  { emoji: "🏎️", name: "Угадай марку",    color: "#FF6B00" },
  { emoji: "📖", name: "Значения слов",    color: "#4FC3F7" },
  { emoji: "🎬", name: "Безумный сценарист", color: "#FF6B35" },
  { emoji: "🕵️", name: "Шпион",             color: "#7b3dd5" },
];

const STEPS = [
  { n: "1", emoji: "🖥️", color: "#ff3cac", title: "Хост открывает сайт", text: "На ноутбуке или TV — создаёт комнату за один клик" },
  { n: "2", emoji: "📱", color: "#ffe600", title: "Игроки сканируют QR", text: "Или вводят код — телефон сразу становится пультом" },
  { n: "3", emoji: "🎮", color: "#3dffa0", title: "Выбираете игру и поехали", text: "32 варианта, всё готово за 30 секунд. Без установок" },
];

const FOR_WHO = [
  { emoji: "🏠", title: "Домашние вечеринки",   text: "Для компании друзей от 2 до 10 человек" },
  { emoji: "🏢", title: "Корпоративы",          text: "Тимбилдинг без скучных конкурсов" },
  { emoji: "☕", title: "Кафе и рестораны",     text: "Развлечение пока ждёте заказ" },
  { emoji: "🎓", title: "Студенческие тусовки", text: "Вечеринка в общаге или на выезде" },
];

const REVIEWS = [
  { name: "Настя", city: "Москва",        stars: 5, text: "Играли на дне рождения — 8 человек, хохотали два часа. Крокодил и Фиббедж — огонь!" },
  { name: "Игорь", city: "Казань",        stars: 5, text: "Взяли PRO на корпоратив. Коллеги в шоке что всё через браузер, ничего не скачивали." },
  { name: "Лера",  city: "Екатеринбург", stars: 5, text: "Своя игра — просто находка. Сделали тематику про наш универ, все были в восторге!" },
];

// 🔥 ОБНОВЛЁННАЯ СТАТИСТИКА С АКЦИЕЙ 6-7
const STATS = [
  { value: "32",   label: "игры на выбор",      color: "#ff3cac" },
  { value: "10",   label: "игроков в комнате",  color: "#ffe600" },
  { value: "0",    label: "установок нужно",    color: "#3dffa0" },
  { value: "30с",  label: "до старта игры",     color: "#9b5de5" },
  { value: "67",   label: "комнат = 670₽",      color: "#ffcc00", isPromo: true }, // Акция 6-7
];

export default function LandingPage() {
  const navigate = useNavigate();
  const isMobile = useMobile();
  const [creating, setCreating] = useState(false);

  const quickStart = async () => {
    if (creating) return;
    setCreating(true);
    try {
      const r = await axios.post(`${API}/rooms`, { game_type: "quiz", host_name: "Host", max_rounds: 5 });
      if (r.data.host_token) sessionStorage.setItem(`host_token_${r.data.room_id}`, r.data.host_token);
      navigate(`/host/${r.data.room_id}`);
    } catch { setCreating(false); }
  };


  // ── МОБИЛЬНАЯ ВЕРСИЯ ──────────────────────────────────────────────────────
  if (isMobile) return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(160deg,#0d0d1a 0%,#1a0a2e 50%,#0d1a2e 100%)", color: "#fff" }}>
      <Navbar />

      <div style={{ maxWidth: 480, margin: "0 auto", padding: "1.5rem 1rem 5rem" }}>

        {/* HERO */}
        <div style={{ textAlign: "center", padding: "2rem 0 2rem" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", background: "#ff3cac18", border: "1.5px solid #ff3cac55", borderRadius: "2rem", padding: "0.3rem 0.9rem", marginBottom: "1.25rem" }}>
            <span style={{ fontSize: "0.72rem", color: "#ff3cac", fontFamily: "'Fredoka One',sans-serif", letterSpacing: "0.06em" }}>🎮 АНАЛОГ JACKBOX НА РУССКОМ</span>
          </div>
          <h1 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "2.6rem", lineHeight: 1.05, color: "#fff", textShadow: "3px 3px 0 #ff3cac, 6px 6px 0 #000", marginBottom: "0.4rem" }}>
            ИГРЫ ДЛЯ<br/>КОМПАНИИ
          </h1>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.7rem", color: "#ffe600", textShadow: "2px 2px 0 #ff8c00, 4px 4px 0 #000", marginBottom: "1.25rem" }}>
            ПРЯМО В БРАУЗЕРЕ
          </h2>
          
          {/* 🔥 АКЦИЯ 6-7 ДЛЯ МОБИЛЬНОЙ ВЕРСИИ */}
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "0.6rem",
            background: "linear-gradient(135deg, #ff3cac22, #ffcc0022)",
            border: "2px solid #ffcc00",
            borderRadius: "3rem",
            padding: "0.5rem 1.25rem",
            margin: "0.75rem auto 1.25rem",
            backdropFilter: "blur(8px)",
            boxShadow: "0 0 15px #ffcc00aa"
          }}>
            <span style={{ fontSize: "1.4rem" }}>⚡</span>
            <span style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.85rem", color: "#ffcc00", letterSpacing: "0.03em" }}>
              SIX SEVEN
            </span>
            <span style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", color: "#fff", background: "#ff3cac", padding: "0.2rem 0.7rem", borderRadius: "2rem", margin: "0 0.15rem" }}>
              67 = 670₽
            </span>
            <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.75rem", color: "#ffcc00" }}>
              ограниченное предложение
            </span>
            <span style={{ fontSize: "1.4rem" }}>🔥</span>
          </div>
          
          <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.95rem", color: "#aaa", lineHeight: 1.6, marginBottom: "0.75rem" }}>
            32 игры без установки. Телефон — пульт, один экран — поле.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
            <button onClick={() => navigate("/join")} className="btn-cartoon btn-success" style={{ padding: "1rem", fontSize: "1.1rem", width: "100%" }}>
              📱 Войти в комнату
            </button>
            <button onClick={() => navigate("/games")} className="btn-cartoon btn-primary" style={{ padding: "0.85rem", fontSize: "1rem", width: "100%" }}>
              🎮 Смотреть все игры
            </button>
            <button onClick={() => navigate("/pro")} style={{ padding: "0.65rem", fontSize: "0.9rem", width: "100%", background: "#9b5de508", border: "1.5px solid #9b5de555", borderRadius: "0.75rem", color: "#c084fc", fontFamily: "'Fredoka One',sans-serif", cursor: "pointer" }}>
              👑 Купить PRO доступ
            </button>
          </div>

          {/* ВИДЕО */}
          <div style={{ marginTop: "1.25rem", borderRadius: "1rem", overflow: "hidden", border: "2px solid #ff3cac44", boxShadow: "0 0 20px #ff3cac22" }}>
            <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
              <video
                src="/video/overview.mp4"
                controls
                playsInline
                poster="/video/overview-poster.png"
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", display: "block", background: "#000" }}
              />
            </div>
          </div>
        </div>

        {/* ЦИФРЫ */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem", marginBottom: "1.5rem" }}>
          {STATS.map((s, i) => (
            <div key={i} style={{ 
              background: s.isPromo ? "linear-gradient(135deg, #ffcc0022, #ff3cac22)" : "#ffffff08", 
              border: s.isPromo ? "2px solid #ffcc00" : `1.5px solid ${s.color}33`,
              borderRadius: "1rem", 
              padding: "1rem", 
              textAlign: "center",
              animation: s.isPromo ? "pulse 1.5s ease-in-out infinite" : "none",
              boxShadow: s.isPromo ? "0 0 15px #ffcc0066" : "none"
            }}>
              <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "2rem", color: s.isPromo ? "#ffcc00" : s.color, lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.78rem", color: s.isPromo ? "#ffcc00" : "#888", marginTop: "0.25rem" }}>{s.label}</div>
              {s.isPromo && <div style={{ fontSize: "0.7rem", color: "#ff3cac", marginTop: "0.3rem" }}>⚡ 6-7 АКЦИЯ ⚡</div>}
            </div>
          ))}
        </div>

        {/* КАК ИГРАТЬ */}
        <div className="card-cartoon" style={{ marginBottom: "1rem", padding: "1.25rem" }}>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.15rem", color: "#ffe600", marginBottom: "1rem", textAlign: "center", textShadow: "2px 2px 0 #ff8c00" }}>КАК ЭТО РАБОТАЕТ</h2>
          {STEPS.map((s, i) => (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem", marginBottom: "0.85rem" }}>
              <div style={{ width: 32, height: 32, borderRadius: "0.6rem", background: s.color, border: "2px solid #000", boxShadow: "2px 2px 0 #000", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Fredoka One',sans-serif", fontSize: "0.95rem", color: "#000", flexShrink: 0 }}>{s.n}</div>
              <div>
                <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.9rem", color: "#fff", marginBottom: "0.15rem" }}>{s.title}</div>
                <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.82rem", color: "#888", lineHeight: 1.5 }}>{s.text}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ОТЗЫВЫ */}
        <div style={{ marginBottom: "1.25rem" }}>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.15rem", color: "#ff3cac", textAlign: "center", marginBottom: "0.85rem" }}>ЧТО ГОВОРЯТ ИГРОКИ</h2>
          {REVIEWS.slice(0, 2).map((r, i) => (
            <div key={i} className="card-cartoon" style={{ padding: "1rem", marginBottom: "0.6rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.4rem" }}>
                <div style={{ width: 30, height: 30, borderRadius: "50%", background: ["#ff3cac","#ffe600","#3dffa0"][i % 3], display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Fredoka One',sans-serif", fontSize: "0.85rem", color: "#000", flexShrink: 0 }}>{r.name[0]}</div>
                <div>
                  <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.85rem", color: "#fff" }}>{r.name} · {r.city}</div>
                  <div style={{ color: "#ffe600", fontSize: "0.7rem" }}>{"★".repeat(r.stars)}</div>
                </div>
              </div>
              <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.82rem", color: "#bbb", lineHeight: 1.5, margin: 0 }}>"{r.text}"</p>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center" }}>
          <button onClick={() => navigate("/how-to-play")} className="btn-cartoon" style={{ padding: "0.75rem 2rem", fontSize: "1rem", background: "#ff3cac", color: "#fff" }}>
            ❓ Как играть?
          </button>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.02); opacity: 0.95; }
        }
      `}</style>
    </div>
  );

  // ── ДЕСКТОП ───────────────────────────────────────────────────────────────
  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(160deg,#0d0d1a 0%,#1a0a2e 50%,#0d1a2e 100%)", color: "#fff", overflow: "hidden" }}>
      <Navbar />

      <div style={{ position: "relative", zIndex: 10, padding: "3rem 2rem 0", maxWidth: 1400, margin: "0 auto" }}>

        {/* HERO */}
        <header style={{ textAlign: "center", marginBottom: "4rem" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", background: "#ff3cac18", border: "1.5px solid #ff3cac55", borderRadius: "2rem", padding: "0.3rem 1rem", marginBottom: "1.75rem" }}>
            <span style={{ fontSize: "0.75rem", color: "#ff3cac", fontFamily: "'Fredoka One',sans-serif", letterSpacing: "0.08em" }}>🎮 АНАЛОГ JACKBOX НА РУССКОМ</span>
          </div>
          <h1 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "clamp(3rem,8vw,6.5rem)", lineHeight: 1, color: "#fff", textShadow: "4px 4px 0 #ff3cac, 8px 8px 0 #000", marginBottom: "0.3rem" }}>
            ИГРЫ ДЛЯ КОМПАНИИ
          </h1>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "clamp(2rem,5vw,4rem)", color: "#ffe600", textShadow: "3px 3px 0 #ff8c00, 6px 6px 0 #000", marginBottom: "1.25rem" }}>
            ПРЯМО В БРАУЗЕРЕ
          </h2>
          
          {/* 🔥 АКЦИЯ 6-7 — БРОСКАЯ ПЛАШКА ДЛЯ ДЕСКТОПА */}
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.75rem",
            background: "linear-gradient(135deg, #ff3cac22, #ffcc0022)",
            border: "2px solid #ffcc00",
            borderRadius: "3rem",
            padding: "0.7rem 2rem",
            margin: "1rem auto 1.8rem",
            backdropFilter: "blur(8px)",
            boxShadow: "0 0 25px #ffcc00aa, 0 0 10px #ff3cac88",
            animation: "glowPulse 2s ease-in-out infinite"
          }}>
            <span style={{ fontSize: "2rem" }}>⚡</span>
            <span style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", color: "#ffcc00", letterSpacing: "0.05em" }}>
              ВИРУСНЫЙ ФОРМАТ SIX SEVEN
            </span>
            <span style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.6rem", color: "#fff", background: "#ff3cac", padding: "0.3rem 1rem", borderRadius: "2.5rem", margin: "0 0.3rem", boxShadow: "0 0 15px #ff3cac" }}>
              67 = 670₽
            </span>
            <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.95rem", color: "#ffcc00", fontWeight: "bold" }}>
              🔥 ОГРАНИЧЕННОЕ ПРЕДЛОЖЕНИЕ
            </span>
            <span style={{ fontSize: "2rem" }}>🔥</span>
          </div>
          
          <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: "1.15rem", color: "#aaa", marginBottom: "2.5rem" }}>
            32 игры · без установок · телефон — пульт · готово за 30 секунд
          </p>

          {/* CTA */}
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap", marginBottom: "0.75rem" }}>
            <button onClick={() => navigate("/games")} className="btn-cartoon btn-primary" style={{ padding: "1rem 2.5rem", fontSize: "1.2rem" }}>
              🎮 Начать играть
            </button>
            <button onClick={() => navigate("/join")} className="btn-cartoon btn-success" style={{ padding: "1rem 2rem", fontSize: "1.1rem" }}>
              Войти по коду →
            </button>
          </div>
          
          {/* 🔥 МАЛЕНЬКАЯ ПЛАШКА ПОД КНОПКАМИ — НАМЁК НА АКЦИЮ */}
          <div style={{ marginTop: "1rem" }}>
            <span style={{ 
              fontFamily: "'Nunito',sans-serif", 
              fontSize: "0.85rem", 
              color: "#ffcc00",
              background: "#ffcc0010",
              padding: "0.3rem 1rem",
              borderRadius: "2rem",
              display: "inline-block"
            }}>
              🎁 Активируй акцию «6-7» — получи 67 комнат за 670₽ вместо 799₽
            </span>
          </div>

          {/* ВИДЕО */}
          <div style={{ maxWidth: 860, margin: "2.5rem auto 0", borderRadius: "1.5rem", overflow: "hidden", border: "2.5px solid #ff3cac55", boxShadow: "0 0 40px #ff3cac33, 0 0 80px #7b2fff22" }}>
            <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
              <video
                src="/video/overview.mp4"
                controls
                playsInline
                poster="/video/overview-poster.png"
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", display: "block", background: "#000" }}
              />
            </div>
          </div>

        </header>

        {/* ЦИФРЫ */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: "1rem", marginBottom: "4rem", maxWidth: 1100, margin: "0 auto 4rem" }}>
          {STATS.map((s, i) => (
            <div key={i} style={{ 
              background: s.isPromo ? "linear-gradient(135deg, #ffcc0022, #ff3cac22)" : "#ffffff07", 
              border: s.isPromo ? "2px solid #ffcc00" : `1.5px solid ${s.color}33`, 
              borderRadius: "1.25rem", 
              padding: "1.5rem 1rem", 
              textAlign: "center",
              animation: s.isPromo ? "pulse 1.5s ease-in-out infinite" : "none",
              boxShadow: s.isPromo ? "0 0 20px #ffcc0066" : "none"
            }}>
              <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "2.8rem", color: s.isPromo ? "#ffcc00" : s.color, lineHeight: 1, marginBottom: "0.4rem" }}>{s.value}</div>
              <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: s.isPromo ? "#ffcc00" : "#888" }}>{s.label}</div>
              {s.isPromo && <div style={{ fontSize: "0.7rem", color: "#ff3cac", marginTop: "0.5rem", fontFamily: "'Fredoka One',sans-serif" }}>⚡ 6-7 ⚡</div>}
            </div>
          ))}
        </div>

        {/* БЕГУЩАЯ СТРОКА */}
        <div style={{ overflow: "hidden", marginBottom: "4rem", maskImage: "linear-gradient(to right,transparent 0%,black 8%,black 92%,transparent 100%)", WebkitMaskImage: "linear-gradient(to right,transparent 0%,black 8%,black 92%,transparent 100%)" }}>
          <div style={{ display: "flex", gap: "0.75rem", animation: "ticker 30s linear infinite", width: "max-content" }}>
            {[...GAMES_TICKER, ...GAMES_TICKER].map((g, i) => (
              <div key={i} style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", background: g.color + "18", border: `1.5px solid ${g.color}44`, borderRadius: "2rem", padding: "0.5rem 1.1rem", fontFamily: "'Fredoka One',sans-serif", fontSize: "0.95rem", color: g.color, whiteSpace: "nowrap", flexShrink: 0 }}>
                <span>{g.emoji}</span>{g.name}
              </div>
            ))}
          </div>
        </div>

        {/* КАК ЭТО РАБОТАЕТ */}
        <section style={{ marginBottom: "5rem" }}>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "clamp(2rem,4vw,3rem)", color: "#ffe600", textShadow: "3px 3px 0 #ff8c00, 5px 5px 0 #000", textAlign: "center", marginBottom: "2.5rem" }}>
            КАК ЭТО РАБОТАЕТ
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "1.5rem", maxWidth: 960, margin: "0 auto" }}>
            {STEPS.map((s, i) => (
              <div key={i} className="card-cartoon" style={{ padding: "2rem 1.75rem", textAlign: "center" }}>
                <div style={{ width: "3.5rem", height: "3.5rem", background: s.color, border: "2.5px solid #000", borderRadius: "1rem", boxShadow: "3px 3px 0 #000", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Fredoka One',sans-serif", fontSize: "1.6rem", color: "#000", margin: "0 auto 1.25rem" }}>{s.n}</div>
                <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.15rem", color: "#fff", marginBottom: "0.6rem" }}>{s.emoji} {s.title}</div>
                <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.95rem", color: "#888", lineHeight: 1.6, margin: 0 }}>{s.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ОТЗЫВЫ */}
        <section style={{ marginBottom: "5rem" }}>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "clamp(2rem,4vw,3rem)", color: "#ff3cac", textShadow: "3px 3px 0 #aa0066, 5px 5px 0 #000", textAlign: "center", marginBottom: "2.5rem" }}>
            ЧТО ГОВОРЯТ ИГРОКИ
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "1.25rem", maxWidth: 1100, margin: "0 auto" }}>
            {REVIEWS.map((r, i) => (
              <div key={i} className="card-cartoon" style={{ padding: "1.75rem" }}>
                <div style={{ color: "#ffe600", fontSize: "1.1rem", marginBottom: "1rem" }}>{"★".repeat(r.stars)}</div>
                <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.95rem", color: "#ccc", lineHeight: 1.65, marginBottom: "1.25rem" }}>"{r.text}"</p>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                  <div style={{ width: 38, height: 38, borderRadius: "50%", background: ["#ff3cac","#ffe600","#3dffa0"][i], display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem", color: "#000", flexShrink: 0 }}>{r.name[0]}</div>
                  <div>
                    <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.95rem", color: "#fff" }}>{r.name}</div>
                    <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.8rem", color: "#666" }}>{r.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ДЛЯ КОГО */}
        <section style={{ marginBottom: "5rem" }}>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "clamp(2rem,4vw,3rem)", color: "#3dffa0", textShadow: "3px 3px 0 #007744, 5px 5px 0 #000", textAlign: "center", marginBottom: "2.5rem" }}>
            ДЛЯ КОГО
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: "1.25rem", maxWidth: 1100, margin: "0 auto" }}>
            {FOR_WHO.map((o, i) => (
              <div key={i} className="card-cartoon" style={{ padding: "1.75rem", textAlign: "center" }}>
                <div style={{ fontSize: "2.75rem", marginBottom: "0.85rem" }}>{o.emoji}</div>
                <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem", color: "#fff", marginBottom: "0.4rem" }}>{o.title}</div>
                <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#777", margin: 0 }}>{o.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── Промо-акция ── */}
        <PromoBanner />

        {/* ФИНАЛЬНЫЙ CTA */}
        <section style={{ textAlign: "center", paddingBottom: "5rem" }}>
          <h2 style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "clamp(2rem,4vw,3rem)", color: "#fff", textShadow: "3px 3px 0 #ff3cac, 6px 6px 0 #000", marginBottom: "0.75rem" }}>
            НАЧНИ ПРЯМО СЕЙЧАС
          </h2>
          <p style={{ fontFamily: "'Nunito',sans-serif", color: "#666", fontSize: "1rem", marginBottom: "2rem" }}>
            Без регистрации · Без установок · 32 игры
          </p>
          
          {/* 🔥 АКЦИОННАЯ ПЛАШКА ПЕРЕД КНОПКАМИ */}
          <div style={{ 
            background: "linear-gradient(90deg, #ff3cac22, #ffcc0022, #ff3cac22)",
            border: "1px solid #ffcc00",
            borderRadius: "2rem",
            padding: "0.6rem 1.5rem",
            marginBottom: "1.5rem",
            display: "inline-flex",
            alignItems: "center",
            gap: "1rem",
            flexWrap: "wrap",
            justifyContent: "center"
          }}>
            <span style={{ fontSize: "1.2rem" }}>🎁</span>
            <span style={{ fontFamily: "'Fredoka One',sans-serif", color: "#ffcc00" }}>ПО АКЦИИ «6-7»:</span>
            <span style={{ fontFamily: "'Fredoka One',sans-serif", color: "#fff", background: "#ff3cac", padding: "0.2rem 0.8rem", borderRadius: "1.5rem" }}>67 комнат = 670₽</span>
            <span style={{ fontFamily: "'Nunito',sans-serif", color: "#aaa" }}>вместо 799₽</span>
            <span style={{ fontSize: "1.2rem" }}>⚡</span>
          </div>
          
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={quickStart} disabled={!!creating} className="btn-cartoon btn-primary" style={{ padding: "1rem 2.5rem", fontSize: "1.2rem" }}>
              {creating ? "⏳ Создаём..." : "🎮 Начать играть"}
            </button>
            <button onClick={() => navigate("/games")} className="btn-cartoon btn-success" style={{ padding: "1rem 2rem", fontSize: "1.1rem" }}>
              Выбрать игру →
            </button>
          </div>
        </section>

      </div>

      <style>{`
        @keyframes ticker { 0% { transform: translateX(0) } 100% { transform: translateX(-50%) } }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.02); opacity: 0.95; }
        }
        @keyframes glowPulse {
          0%, 100% { box-shadow: 0 0 25px #ffcc00aa, 0 0 10px #ff3cac88; }
          50% { box-shadow: 0 0 40px #ffcc00ff, 0 0 20px #ff3cacff; }
        }
      `}</style>
    </div>
  );
}